<template>
<v-app id="app" v-bind:style="stylePagina" >
  <v-container v-bind:style="stylePagina"  fluid>
    <v-row justify="center" align="center"  class="mt-12 mb-12 pb-12"  >
      <v-col cols="12"  xl="12" lg="12" md="12" sm="12"  v-bind:style="styleCuadro" class="mt-12 pt-12 pb-12">
        <v-row justify="center" align="center" >
          <v-col cols="12" lg="6" xl="6" sm="12" >
            <center><v-img style="width: 60%;" :src="logo"></v-img></center><br/>
            <v-alert
                :value="alerterror"
                color="yellow"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              {{texterror}}
            </v-alert>
          </v-col>

        </v-row>
        <v-row v-if="premiomayor">
          <v-col cols="12" lg="12" xl="12" md="12">
          <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/28juliomallaventura/FELICITACIONES-ai.png">
          </v-img>
          </v-col>
          <v-col cols="12" lg="12" xl="12" md="12">
            <center>

              <v-btn v-bind:style="btnPag" href="#" @click="volver" > Volver</v-btn>
            </center>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-col cols="12" lg="12" xl="12" md="10" sm="12" >
        <v-row justify="center" align="center" v-if="conformulario">
          <v-col v-if="campoInscritos" cols="10" sm="10" md="10" lg="10" xl="10" class="ma-2  pa-1">
            <p v-bind:style="styleText">Los inscritos del dia :  {{inscritosDia}}</p>
          </v-col>
          <v-col cols="10" sm="10" md="10" lg="10" xl="10" class="ma-2  pa-1">
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-bind:style="styleComponent" v-model="editedItem.persona.nombrePersona" :placeholder="labelNombre" />
          </v-col>

          <v-col v-if="campodni" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodni" v-on:keyup="handleInputNumero" v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.dniPersona" :placeholder="labelDNI" />
          </v-col>
          <v-col  v-if="campotelefono" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-if="campotelefono"  v-on:keyup="handleInputNumero" v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.telefonoPersona" :placeholder="labelTelefono" />
          </v-col>
          <v-col  v-if="campoemail" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1">
            <input type="email"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }" v-if="campoemail" v-on:change="handleEmailChange"   v-bind:style="styleComponent" @input="handleInput"  v-model="editedItem.persona.emailPersona"  :placeholder="labelEmail" />
          </v-col>
          <v-col v-if="campodireccion" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodireccion"  v-bind:style="styleComponent" v-model="editedItem.persona.direccionPersona" :placeholder="labelDireccion" />
          </v-col>
          <v-col v-if="camporef1"  cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="camporef1"  v-bind:style="styleComponent" v-model="editedItem.persona.ref1Persona" :placeholder="labelRef1" />
          </v-col>
          <v-col  v-if="camporef2" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef2"  v-bind:style="styleComponent" v-model="editedItem.persona.ref2Persona" :placeholder="labelRef2" />
          </v-col>
          <v-col  v-if="camporef3" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef3"  v-bind:style="styleComponent" v-model="editedItem.persona.ref3Persona" :placeholder="labelRef3" />
          </v-col>
          <v-col  v-if="camporef4" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef4"  v-bind:style="styleComponent" v-model="editedItem.persona.ref4Persona" :placeholder="labelRef4" />
          </v-col>
          <v-col  v-if="camporef5" cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef5"  v-bind:style="styleComponent" v-model="editedItem.persona.ref5Persona" :placeholder="labelRef5" />
          </v-col>
          <v-col cols="10" sm="10" md="10" lg="10" class="mt-4 mb-4" style="color: white !important; font-size:1.5rem;">
            <v-row justify="center" align="center">
              <v-col cols="3"><v-checkbox
                  v-model="editedItem.aceptoCondicion"
                  :rules="[v => !!v || 'Debes aceptar para continuar']"
                  label="Acepto los "
                  required
                  color="#ffffff"

                  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"

              ></v-checkbox></v-col>
              <v-col cols="9">
                <a style="text-decoration:none; color: white !important;" :href="linkcondiciones" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   target="_blank">Términos y Condiciones</a>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-2  pa-1 text-center" >

            <center> <v-btn v-bind:style="btnPag" @click="registrar">Registrarse</v-btn></center>
          </v-col>
        </v-row>
        <v-row v-else justify="center" align="center" >

          <v-col cols="12" lg="12" xl="12" md="12">
<section class="vue-winwheel" >

      <div class="mobile-container">
        <div class="wheel-wrapper">
          <div class="canvas-wrapper">
           <div  v-bind:style="styleFlecha"  ><center><img width="150px" style="margin-bottom:-50px; margin-left: 4px;" :src="flechaabajo" />
            </center></div>
            <canvas id="canvas" :width="widthRuleta" :height="heightRuleta" v-bind:style="styleFondoRuleta">
              <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try Google Chrome.</p>
            </canvas>
          </div>

        </div>
      </div>



</section>
          </v-col>
          <v-col cols="12" lg="12" xl="12" md="12" v-if="!volverbtn">
<center>

          <a  v-bind:style="btnPag" href="#" @click.prevent="startSpin()" v-if="!loadingPrize && !wheelSpinning"> {{buttontext}}</a>
</center>
        </v-col>
          <v-col cols="12" lg="12" xl="12" md="12" v-if="volverbtn">
            <center>

              <v-btn v-bind:style="btnPag" href="#" @click="volver" >Volver</v-btn>
            </center>
          </v-col>
        </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/infinity.gif"

      />
    </v-overlay>
  </v-container></v-app>
</template>

<script>
import * as Winwheel from '@/plugins/Winwheel2222'
import axios from "axios";
import EmailAutocomplete from "email-autocomplete";

export default {
  name: 'Ruleta',
  components:{

  },
  props: {
    msg: String
  },
  data(){
    return{
      loadingPrize: false,
      theWheel: null,
      modalPrize: false,
      buttontext:'GIRAR',
      widthRuleta: 500,
      heightRuleta: 500,
      giro: true,
      premiomayor:false,
      buttontext2:'VOLVER',
      conRuleta:false,
      imgRuleta:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/directv/ruleta.png',
      numberEso:0,
      flechaabajo:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/win/flechabajo.png',
      wheelPower: 1,
      alerterror:null,
      isWhitePlaceholder: true,
      prizeNumber: 2,
      texterror:'',
      wheelSpinning: false,
      prizeName: 'BUY 1 GET 1',
      WinWheelOptions: {
        textFontSize: 24,
        textFontFamily: 'Tahoma',
        strokeStyle:'#FFFFFF',
        outerRadius: 212,
        innerRadius: 75,
        lineWidth: 12
      },
      juegodisenio: {},
      conformulario:false,
      grabarformulario:false,
      arrayganador:{},
      logo:'',
      overlay:false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      volverbtn:false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campodni:false,
      campotipocarnet: false,
      campocondiciones:false,
      campoemail:false,
      isMobile: false,
      outerRadius: 0,
      innerRadius: 0,
      camporef1: false,
      camporef2:false,
      camporef3:false,
      camporef4:false,
      camporef5:false,
      campoInscritos:false,
      condiciones: 'Soy Mayor de Edad',
      linkcondiciones:'',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Numero de Documento',
      labelDistrito: 'Comuna',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de nacimiento',
      labelEmail:'Correo Electrónico',
      labelSexo:'Género',
      labelTelefono:'Telefono',
      labelDireccion:'Direccion',
      inscritosDia:0,
      labelRef1:'',
      labelRef2:'',
      labelRef3:'',
      fontGameSize: 18,
      labelRef4:'',
      labelRef5:'',
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Futura Bk BT',
        color: '#1E3D90',
        height:'1920px',
        width:'100%',

      },
      styleText:{
        color:'#ffffff',
        width:'100%',
        padding:'2%',
        fontSize:'1.5rem',
      },
      styleComponent:{
        color:'#ffffff',
        width:'100%',
        padding:'2%',
        fontSize:'1.5rem',
      },
      styleCuadro:{
        color:'#1E3D90',
      },
      styleFlecha:{
        width: '900px',
        position: 'relative',
        zIndex: 9999

      },
      btnPag: {
        color:'white',
        cursor: 'pointer',
        fontSize:'2.5rem',
        margin: '0 0.2rem',
        height:'100px',
        width: '75%',
        border: 'none',
        borderRadius: '10px',
        padding: '10px 15px',
        textDecoration: 'none'
      },
      cssProps:{
        backgroundSize:'cover',
        backgroundRepeat : 'none',
        width:'1024px',
        height:'1024px',
        position: 'absolute',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      styleFondoRuleta:{
        backgroundImage:'',
        textAlign: 'center',
    backgroundSize: '100% 100%',
    width: 'auto',
    height: 'auto',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
      },
      wheelProps:{
        position:'absolute',
        bottom:'10%',
        right:'5%'
      },
      editedItem:{
        ganador:false,
        condiciones:false,
        persona:{
          fechaNacimientoPersona:null,
          dniPersona:'',
          fotoPersona:'',
          nombrePersona:'',
          tipoDocumentoPersona:'',
          aceptoCondicion:false,
          emailPersona:'',
          telefonoPersona:'',
          direccionPersona:'',
          sexoPersona:'',
          distritoPersona:'',
          ref1Persona:'',
          ref2Persona:'',
          ref3Persona:'',
          ref4Persona:'',
          ref5Persona:''
        }

      },

      defaultItem:{
        ganador:false,
        condiciones:false,
        persona:{
          fechaNacimientoPersona:null,
          dniPersona:'',
          fotoPersona:'',
          nombrePersona:'',
          tipoDocumentoPersona:'',
          emailPersona:'',
          telefonoPersona:'',
          direccionPersona:'',
          sexoPersona:'',
          distritoPersona:'',
          ref1Persona:'',
          ref2Persona:'',
          ref3Persona:'',
          ref4Persona:'',
          ref5Persona:''
        }

      },
      segments:[
        { fillStyle: "#ee1c24", text: "300" },
        { fillStyle: "#3cb878", text: "450" },
        { fillStyle: "#f6989d", text: "600" },
        { fillStyle: "#00aef0", text: "750" },
        { fillStyle: "#f26522", text: "500" },
      ]
    }
  },
  methods:{
    showPrize () {
      if(this.prizeNumber === 1){
        this.premiomayor = false
      }else{
        this.modalPrize = true
      }

    },
    comienzo(){

      this.editedItem.ganador = false;
      this.editedItem.condiciones = false;
      this.editedItem.persona.fechaNacimientoPersona = null
      this.editedItem.persona.dniPersona = ""
      this.editedItem.persona.fotoPersona = ""
      this.editedItem.persona.nombrePersona = ""
      this.editedItem.persona.tipoDocumentoPersona = ""
      this.editedItem.persona.emailPersona = ""
      this.editedItem.persona.telefonoPersona = ""
      this.editedItem.persona.direccionPersona = ""
      this.editedItem.persona.sexoPersona = ""
      this.editedItem.persona.distritoPersona = ""
      this.editedItem.persona.ref1Persona = ""
      this.editedItem.persona.ref2Persona = ""
      this.editedItem.persona.ref3Persona = ""
      this.editedItem.persona.ref4Persona = ""
      this.editedItem.persona.ref5Persona = ""
      this.unsolo=true
      this.volverbtn=false
      this.alerterror=false
      this.texterror=''
      this.conformulario=false
      this.grabarformulario=false
      this.tag =  this.$route.params.tag;
      this.damedisenio();
      const domains = ['gmail.com', 'hotmail.com'];
      const autocompleteOptions = {
        domains: domains,
        topLevelDomains: ['com', 'net', 'org']
      };
      // Inicializar el autocompletar en el campo de email
      const emailInput = document.querySelector('input[type="email"]');
      const emailAutocomplete = new EmailAutocomplete(emailInput, autocompleteOptions);
      emailAutocomplete.on('autocompleted', domain => {
        if (this.editedItem.persona.emailPersona.includes('@')) {
          const [username] = this.editedItem.persona.emailPersona.split('@');
          this.editedItem.persona.emailPersona = username + '@' + domain;
        } else {
          this.editedItem.persona.emailPersona = domain;
        }
      });

    },
    handleInput() {
      // Validar el formato del email
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.persona.emailPersona);

      if (isValidEmail) {
        // El email es válido
        console.log('Email válido: ' + this.editedItem.persona.emailPersona);
      } else {
        // El email no es válido
        console.log('Email inválido');
      }
    },
    handleInputNumero(event) {
      const inputValue = event.target.value;
      // Eliminar cualquier carácter que no sea un número
      const numericValue = inputValue.replace(/\D/g, '');
      // Actualizar el valor del campo de entrada solo con números
      event.target.value = numericValue;
    },
    handleEmailChange(event) {
      const inputValue = event.target.value;
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!regex.test(inputValue)) {
        // El valor no cumple con el formato de correo electrónico, se puede mostrar un mensaje de error o realizar alguna acción adicional.
        console.log('Formato de correo electrónico inválido');
        // También puedes restablecer el valor del campo de entrada si no cumple con el formato
        event.target.value = '';
      }
    },
    checkMobile() {
      const mobileWidthThreshold = 600; // Umbral de ancho para dispositivos móviles

      // Obtener el ancho de la ventana del navegador
      const windowWidth = document.documentElement.clientWidth
      console.log(windowWidth)
if( windowWidth > mobileWidthThreshold){
  this.isMobile = false
}else{
  this.isMobile = true;
}

      console.log(this.isMobile)
      this.damedisenio()
    },
    registrar(){
      if(navigator.onLine){
        if(!this.editedItem.condiciones){
          if(this.editedItem.persona.nombrePersona.length > 2){
            if(this.editedItem.persona.emailPersona.length > 6){
              if(this.editedItem.persona.direccionPersona.length > 1){
                this.conformulario=false
                this.damestocks()
              }else{
                this.alerterror = true;
                this.texterror= "Debes Completar una Dirección correcta"
              }
            }else{
              this.alerterror = true;
              this.texterror= "Debes Completar un Correo correcto"
            }


          }else{
            this.alerterror = true;
            this.texterror= "Debes Completar tu nombre"
          }
        }else{
          this.alerterror = true;
          this.texterror= "Debes Aceptar los Términos y Condiciones"
        }}else{
        this.alerterror=true
        this.texterror="VERIFIQUE LA CONEXION A INTERNET"
        this.volver()
      }
    },
    volver(){
      this.conformulario = this.grabarformulario;
      this.premiomayor = false
      this.volverbtn = false
      this.comienzo()
    },
    playSound() {
      let audio = new Audio(require('@/assets/music/ruleta.mp3'));
      audio.pause();
      audio.currentTime = 0;
      audio.play();
    },
    damepremio(){
      this.overlay = true
      axios
          .get('juegos/ruleta/premio/'+this.tag)
          .then(response => {
            this.prizeNumber = response.data
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    damedisenio(){
      this.overlay = true
      axios
          .get('disenio/juego/'+this.tag)
          .then(response => {
            this.juegodisenio = response.data;

            this.logo = this.juegodisenio.logo;
            this.conformulario = this.juegodisenio.juego.conFormulario;
            this.grabarformulario = this.juegodisenio.juego.conFormulario;
            this.styleCuadro.backgroundColor = this.juegodisenio.fondoCuadro + " !important";
            this.stylePagina.backgroundColor = this.juegodisenio.backgroundColor + " !important";
            this.styleComponent.backgroundColor = this.juegodisenio.backCabeceraColor + " !important";
            this.styleComponent.color = this.juegodisenio.colorInput + " !important";
            this.condiciones = this.juegodisenio.condiciones;
            this.linkcondiciones = this.juegodisenio.linkCondiciones;
            this.campoapmaterno= this.juegodisenio.campoapmaterno;
            this.labelApellidoMaterno = this.juegodisenio.labelApmaterno;
            this.labelApellidoPaterno = this.juegodisenio.labelAppaterno;
            this.labelNombre = this.juegodisenio.labelNombre;
            this.labelEmail = this.juegodisenio.labelEmail;
            this.labelTelefono = this.juegodisenio.labelTelefono;
            this.campotelefono = this.juegodisenio.campotelefono;
            this.campoinvitado = this.juegodisenio.campoinvitado;
            this.camposexo = this.juegodisenio.camposexo;
            this.campodireccion = this.juegodisenio.campodireccion;
            this.campodni = this.juegodisenio.campodni;
            this.campodistrito = this.juegodisenio.campodistrito;
            this.labelDireccion= this.juegodisenio.labelDireccion;
            this.campofecnac  = this.juegodisenio.campofecnac;
            this.campoemail = this.juegodisenio.campoemail;
            this.campoInscritos = this.juegodisenio.mostrarInscritos;
            this.inscritosDia = this.juegodisenio.inscritosDia;
            this.logoexist = this.juegodisenio.logoCargado;
            this.logoimg = this.juegodisenio.logo;
            this.stylePagina.color = this.juegodisenio.colorText + " !important";
            this.btnPag.color = this.juegodisenio.colorTxtBoton + " !important";
            this.btnPag.backgroundColor = this.juegodisenio.colorBgBoton+ " !important";
            this.labelRef1 = this.juegodisenio.labelRef1;
            this.labelRef2 = this.juegodisenio.labelRef2;
            this.labelRef3 = this.juegodisenio.labelRef3;
            this.labelRef4 = this.juegodisenio.labelRef4;
            this.labelRef5 = this.juegodisenio.labelRef5;
            this.camporef1 = this.juegodisenio.camporef1;
            this.camporef2 = this.juegodisenio.camporef2;
            this.camporef3 = this.juegodisenio.camporef3;
            this.camporef4 = this.juegodisenio.camporef4;
            this.camporef5 = this.juegodisenio.camporef5;
            this.stylePagina.backgroundImage = "url('"+this.juegodisenio.backgroundImage+"')";
            this.stylePagina.backgroundSize = 'cover'
            this.flechaabajo = this.juegodisenio.flechaRuleta
            this.buttontext = this.juegodisenio.txtBoton
            if(this.isMobile){
              console.log('detecta movil')
              this.widthRuleta = this.juegodisenio.anchoRuletaMob
              this.heightRuleta = this.juegodisenio.alturaRuletaMob
              this.fontGameSize = this.juegodisenio.fontGameSizeMob

              this.outerRadius = this.juegodisenio.outerRadiusMob - 25
              this.innerRadius = this.juegodisenio.innerRadiusMob
            }else{
              this.fontGameSize = this.juegodisenio.fontGameSize

              this.widthRuleta = this.juegodisenio.anchoRuleta
              this.heightRuleta = this.juegodisenio.alturaRuleta
              this.outerRadius = this.juegodisenio.outerRadius - 50
              this.innerRadius = this.juegodisenio.innerRadius
            }
            this.styleFondoRuleta.width = this.widthRuleta
            this.styleFondoRuleta.height = this.heightRuleta
            this.styleFondoRuleta.marginLeft = this.calculateMarginLeft(this.widthRuleta)
            this.styleFondoRuleta.backgroundImage = "url('"+this.juegodisenio.fondoRuleta+"')"
            this.conRuleta = this.juegodisenio.conRuleta
            this.imgRuleta = this.juegodisenio.imgRuleta
            this.styleFlecha.width = this.widthRuleta + 'px'
            this.styleText.fontSize = this.juegodisenio.fontSize + 'pt'
            this.styleComponent.fontSize = this.juegodisenio.fontSize + 'pt'

            this.styleFlecha.marginLeft = this.calculateMarginLeft(this.widthRuleta)
                if(navigator.onLine) {
            this.damestocks()
                }
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    hidePrize () {
      this.modalPrize = false
    },
    calculateMarginLeft(wdst) {
      const windowWidth = document.documentElement.clientWidth;
      const elementWidth = wdst;
      const marginLeft = (windowWidth - elementWidth) / 2 ;
      const marginLeft2 = marginLeft - 100;
      return marginLeft2 + 'px';
    },
    damestocks(){

      if(navigator.onLine) {
        this.overlay = true
        this.damepremio()
        axios
            .get('juegos/stocks/' + this.tag)
            .then(response => {
              this.premios = response.data
              this.segments = [];
              response.data.forEach((entry)=>{

                let obj = {
                  fillStyle : entry.fondoColor,
                  text: entry.premio,
                  textFillStyle: entry.color,
                  textFontSize: this.fontGameSize
                }

                this.segments.push(obj)
              });
              this.overlay = false
              this.initSpin()
            })
            .catch((error) => {
              console.log(error);
              this.overlay = false
            });
      }else{
        this.alerterror=true
        this.texterror="VERIFIQUE LA CONEXION A INTERNET"
        this.volver()}
    },
    startSpin () {
      if(this.conRuleta){
        if (this.wheelSpinning === false) {
          this.theWheel.startAnimation()
          this.wheelSpinning = true
        let loadedImg = new Image();
        loadedImg.src = this.imgRuleta;
        loadedImg.width = this.widthRuleta
          loadedImg.height = this.heightRuleta
        this.theWheel = new Winwheel.Winwheel2222({
          'drawMode' : 'image',
          'numSegments'  : 7,
          'wheelImage': loadedImg,
          animation: {
            type: 'spinToStop',
            duration: 13,
            spins: 3,
            callbackFinished: this.onFinishSpin,

          }
        })
        loadedImg.onload = () => {
          this.theWheel.wheelImage = loadedImg;
          this.theWheel.draw();
        };
          var prizeNumber2 = Math.floor(Math.random() * this.segments.length) // or just get from Backend
          // var stopAt2 = 360 / this.segments.length * prizeNumber2 - 360 / this.segments.length / 2 // center pin
          var stopAt2 = 360 / this.segments.length * prizeNumber2 - Math.floor(Math.random() * 60) //random location
          this.theWheel.animation.stopAngle = stopAt2
          this.theWheel.startAnimation()
          this.wheelSpinning = false
          this.giro =false
          this.numberEso = stopAt2
        }
      }else{
      if (this.wheelSpinning === false) {
        this.theWheel.startAnimation()
        this.wheelSpinning = true
        this.theWheel = new Winwheel.Winwheel2222({
          textFontSize: this.fontGameSize,
          textFontFamily: 'Tahoma',
          strokeStyle:'#FFFFFF',
          outerRadius: this.outerRadius,
          innerRadius: this.innerRadius,
          textAlignment:'outer',
          numSegments: this.segments.length,
          segments: this.segments,
          animation: {
            type: 'spinToStop',
            duration: 13,
            spins: 3,
            callbackFinished: this.onFinishSpin,
            callbackSound: this.playSound,

          },
          'pins' :// Turn pins on.
              {
                'number' : this.segments.length,
                'fillStyle' : 'silver',
                'outerRadius': 4,
              }
        })

        // example input prize number get from Backend
        // Important thing is to set the stopAngle of the animation before stating the spin.

        // or just get from Backend
        //   var stopAt = 360 / this.segments.length * this.prizeNumber - 360 / this.segments.length / 2 // center pin
        var prizeNumber = Math.floor(Math.random() * this.segments.length)
        var stopAt = 360 / this.segments.length * prizeNumber - Math.floor(Math.random() * 60) //random location
        this.theWheel.animation.stopAngle = stopAt
        this.theWheel.startAnimation()
        this.wheelSpinning = false
        this.giro =false
        this.numberEso = stopAt
        if(navigator.onLine){
          let premio = this.premios.find(prize => prize.nroPremio === this.prizeNumber);
        var ganador = false
        if(premio.esPremio){
          ganador = true
        }

          this.grabarpremio(ganador,premio.id)
        }
      }}
    },
   grabarpremio(ganador,premioId){
     var bodyFormData = new FormData();
     bodyFormData.append("data",JSON.stringify(this.editedItem.persona))
     bodyFormData.append("tag",this.tag)
     bodyFormData.append("juego","Ruleta")
     bodyFormData.append("ganador",ganador)
     bodyFormData.append("premioId",premioId)
     this.overlay = true
     axios
         .post('inscripciones/registrar',bodyFormData)
         .then(response => {
           let ticketMin = response.data;
           console.log(ticketMin)
           this.volverbtn = true
           this.overlay = false
         })
         .catch((error)  => {
           console.log(error);
           this.overlay = false
         });
   },
    resetWheel () {
      if(this.conRuleta){

        let loadedImg = new Image();

        loadedImg.src = this.imgRuleta;

        this.theWheel = new Winwheel.Winwheel2222({
          'drawMode' : 'image',
          'numSegments'  : 7,
          'wheelImage': '',
          animation: {
            type: 'spinToStop',
            duration: 13,
            spins: 3,
            callbackFinished: this.onFinishSpin,
          },
        })
        loadedImg.onload = () => {

          this.theWheel.wheelImage = loadedImg;
          this.theWheel.draw();
        };
        if (this.wheelSpinning) {
          this.theWheel.stopAnimation(false) // Stop the animation, false as param so does not call callback function.
        }
        this.theWheel.rotationAngle = 0 // Re-set the wheel angle to 0 degrees.
        this.theWheel.draw() // Call draw to render changes to the wheel.
        this.wheelSpinning = false
      }else{

        this.theWheel = new Winwheel.Winwheel2222({
          textFontSize: this.fontGameSize,
          textFontFamily: 'Tahoma',
          strokeStyle:'#FFFFFF',
          outerRadius: this.outerRadius,
          innerRadius: this.innerRadius,
          textAlignment:'outer',
          numSegments: this.segments.length,
          segments: this.segments,
          animation: {
            type: 'spinToStop',
            duration: 13,
            spins: 3,
            callbackFinished: this.onFinishSpin,
            callbackSound: this.playSound,

          },
          'pins' :// Turn pins on.
              {
                'number' : this.segments.length,
                'fillStyle' : 'silver',
                'outerRadius': 4,
              }
        })

      if (this.wheelSpinning) {
        this.theWheel.stopAnimation(false) // Stop the animation, false as param so does not call callback function.
      }

      this.theWheel.rotationAngle = 0 // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw() // Call draw to render changes to the wheel.
      this.wheelSpinning = false // Reset to false to power buttons and spin can be clicked again.
      }
    },

    initSpin () {
      this.loadingPrize = true
      this.resetWheel()
      this.loadingPrize = false
    },
    onFinishSpin (indicatedSegment) {
      this.prizeName = indicatedSegment.text
      this.showPrize()
    },
  },
  mounted () {
    this.tag =  this.$route.params.tag;
    this.checkMobile();

    // this.resetWheel()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style >
.grecaptcha-badge{
  display: none;
}
.vue-winwheel {

}
.vue-winwheel h1 {
  color: #b32656;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 36px;
  line-height: 90px;
  letter-spacing: 4px;
  margin: 0;
}
.vue-winwheel h2 {
  margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content {
  width: calc(100vw - 30px);
  padding-top: 52px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content h2 {
  text-transform: uppercase;
  color: #b32656;
  margin-bottom: 16px;
  margin-top: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 18px;
  letter-spacing: 1.1px;
  margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: black;
  text-align: center;
  line-height: 25px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p strong {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss {
  top: 12px;
  right: 12px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss i.icon_close {
  font-size: 30px;
  color: #da2a52;
}
.vue-winwheel canvas#canvas {
  position: relative;

}

.vue-winwheel .canvas-wrapper:after {
  content: '';
  display: none;
  width: 0px;
  height: 0px;
  margin: auto;
  border-radius: 100%;
  border: 4px solid white;
  box-sizing: content-box;
}
.vue-winwheel .canvas-wrapper:before {
  content: '';
  display: block;
  width: 480px;
  height: 480px;
  position: absolute;
  border-radius: 100%;
  top: 0;
}
.vue-winwheel .wheel-wrapper {
  position: relative;
}
.vue-winwheel .wheel-wrapper:before {
  content: '';
  width: 50px;
  height: 50px;
  position: absolute;
  top:-50px;
  left: 180px;
  display: block;
  z-index: 99999;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.vue-winwheel .wheel-wrapper .button-wrapper {
  margin: 0 10px 0 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 231px;
  height: 118px;
}
.vue-winwheel .wheel-wrapper .btn {
  padding: 0 58px !important;
  background: #FFFFFF;

  height: 40px;
  line-height: 40px;
  color: #FF5A00;
  font-weight: bold;
  text-decoration: none;
  border-radius: 2px;
  font-family: 'Tahoma';
  letter-spacing: 2px;
}
</style>